import { render, staticRenderFns } from "./Heading1.vue?vue&type=template&id=ebf9d4c2&scoped=true&"
import script from "./Heading1.vue?vue&type=script&lang=ts&"
export * from "./Heading1.vue?vue&type=script&lang=ts&"
import style0 from "./Heading1.vue?vue&type=style&index=0&id=ebf9d4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf9d4c2",
  null
  
)

export default component.exports